import React, { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Space } from "antd";
import "./add_edit_picking_item.css";
import { SalesOrderItem } from "../../components/hoc_picking_list";
import LocationCodeRackPickingList, { RackLocationRecord } from "./location_code_rack_picking_list";
import axios from "axios"
const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface AddEditPickingItemProps {
    editData?: SalesOrderItem | null;
    warehouseGroup?: string;
    onSave: (item: SalesOrderItem) => void;
    onCancel: () => void;
}

const AddEditPickingItem: React.FC<AddEditPickingItemProps> = ({ editData, warehouseGroup, onSave, onCancel }) => {
    const [form] = Form.useForm();
    const [isLocationModalVisible, setIsLocationModalVisible] = useState(false);

    useEffect(() => {
        if (editData) {
            form.setFieldsValue({
                item_code: editData.item_code,
                item_name: editData.item_name,
                location_code_rack: editData.location_code_rack,
                uom: editData.uom,
                available_quantity: editData.available_quantity,
                demand_quantity: editData.demand_quantity,
                supply_quantity: editData.supply_quantity,
                pick_qty: editData.pick_quantity,
            });
        } else {
            form.resetFields();
        }
    }, [editData, form]);

    const onFinish = (values: any) => {
        let updatedItem: SalesOrderItem;
        if (editData) {
            updatedItem = {
                ...editData,
                location_code_rack: values.location_code_rack,
                pick_quantity: parseFloat(values.pick_qty),
            };
        } else {
            updatedItem = {
                key: Date.now(),
                item_code: values.item_code,
                item_name: values.item_name,
                uom: values.uom,
                location_code_rack: values.location_code_rack,
                available_quantity: parseFloat(values.available_quantity),
                demand_quantity: parseFloat(values.demand_quantity),
                supply_quantity: 0,
                pick_quantity: parseFloat(values.pick_qty),
            };
        }

        onSave(updatedItem);
    };

    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    return (

        <div id="ilkd" style={transformStyle}>
            <div className="gjs-grid-row" id="ifad">
                <div className="gjs-grid-column" id="iruq">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 400 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '590px' } }}
                        className="custom-info-purchase-request"
                        preserve={false}
                        onFinish={onFinish}
                    >

                        <div style={{ display: "flex", gap: "10px", marginBottom: "5px", alignItems: "center" }}>
                            <Form.Item
                                label="Item Code"
                                name="item_code"
                                style={{
                                    marginBottom: "0px", width: "100%"
                                }}
                            >
                                <Input placeholder="" disabled />
                            </Form.Item>
                            <Button
                                type="primary"
                                id="search_item"
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{
                                            width: "40px",
                                            height: "20px",
                                        }}
                                    >
                                        <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                        <path
                                            fillRule="evenodd"
                                            d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                            clipRule="evenodd"
                                        />
                                        <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                    </svg>
                                }
                            />
                        </div>
                        <Form.Item
                            label="Item Name"
                            name="item_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input
                                placeholder=""
                                style={{ width: "100%" }}
                                disabled
                            />

                        </Form.Item>
                        <Form.Item label="Location" style={{ marginBottom: "5px" }}>
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Form.Item name="location_code_rack" noStyle style={{ width: "85%" }}>
                                    <Input placeholder="" style={{ width: "90%" }} readOnly />
                                </Form.Item>
                                <Button
                                    type="primary"
                                    id="location_code_rack_picking_list"
                                    onClick={() => setIsLocationModalVisible(true)}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{ width: "22px", height: "22px" }}>
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path
                                                fillRule="evenodd"
                                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                clipRule="evenodd"
                                            />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>
                                    }
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="UOM"
                            name="uom"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input
                                placeholder=""
                                style={{ width: "100%" }}
                                disabled
                            />

                        </Form.Item>
                        <Form.Item
                            label="Available Qty"
                            name="available_quantity"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input
                                placeholder=""
                                style={{ width: "100%" }}
                                disabled
                            />

                        </Form.Item>
                        <Form.Item
                            label="Demand Qty"
                            name="demand_quantity"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input
                                placeholder=""
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Form.Item>
                        <Form.Item
                            label="Pick Qty"
                            name="pick_qty"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    validator: async (_, value) => {
                                        const availableQty = parseFloat(form.getFieldValue('available_quantity'));
                                        const demandQty = parseFloat(form.getFieldValue('demand_quantity'));
                                        const supplyQtyInForm = parseFloat(form.getFieldValue('supply_quantity'));
                                        const pickQty = parseFloat(value);
                                        const originalPickQtyOfThisItem = parseFloat(editData?.pick_quantity as string || '0');
                                        const pickedByOtherLists = supplyQtyInForm - originalPickQtyOfThisItem;
                                        const remainingDemandLimit = demandQty - pickedByOtherLists;
                                        if (isNaN(pickQty)) {
                                            return Promise.reject(new Error('Kuantitas Pick harus berupa angka.'));
                                        }
                                        if (pickQty < 0) {
                                            return Promise.reject(new Error('Kuantitas Pick tidak boleh negatif.'));
                                        }

                                        if (!isNaN(pickQty) && !isNaN(availableQty) && pickQty > availableQty) {
                                            return Promise.reject(new Error('Stok tidak cukup! (Out of Stock!)'));
                                        }
                                        if (!isNaN(pickQty) && !isNaN(remainingDemandLimit) && pickQty > remainingDemandLimit) {
                                            return Promise.reject(new Error(`Kuantitas Pick melebihi sisa permintaan! (Maksimal: ${remainingDemandLimit})`));
                                        }
                                        if (!isNaN(pickQty) && !isNaN(demandQty) && pickQty > demandQty) {
                                            return Promise.reject(new Error('Permintaan terlalu banyak! (Demand is too much!)'));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input
                                placeholder=""
                                style={{ width: "100%" }}
                            />

                        </Form.Item>
                        <Form.Item
                            label="Supply Qty"
                            name="supply_quantity"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input
                                placeholder=""
                                style={{ width: "100%" }}
                                disabled
                            />

                        </Form.Item>
                        <Space>
                            <Button
                                type="primary"
                                id="add_item"
                                style={{
                                    height: "40px",
                                    width: "105px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                }
                                htmlType="submit"
                            >
                                OK
                            </Button>
                            <Button
                                type="primary"
                                id="cancel"
                                style={{
                                    height: "40px",
                                    width: "105px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                }
                                onClick={onCancel}
                            >
                                Cancel
                            </Button>
                        </Space>
                    </Form>
                    <Modal
                        title="Browse Location Rack"
                        open={isLocationModalVisible}
                        onCancel={() => setIsLocationModalVisible(false)}
                        width="600px"
                        footer={null}
                        destroyOnClose
                    >
                        <LocationCodeRackPickingList
                            warehouseGroup={warehouseGroup}
                            itemCode={form.getFieldValue('item_code')}
                            onSelectLocation={async (record: RackLocationRecord) => {
                                const currentItemCode = form.getFieldValue('item_code');
                                try {
                                    const response = await axios.get(`${backendUrl}/api/spareparts-stocks/check-location`, {
                                        params: {
                                            item_code: currentItemCode,
                                            location_code_rack: record.code_rack,
                                            warehouse: warehouseGroup,
                                        }
                                    });
                                    if (!response.data.exists) {
                                        Modal.warning({
                                            title: "Peringatan",
                                            content: "Location code tidak cocok dengan item!",
                                        });
                                        return;
                                    }
                                    form.setFieldsValue({ location_code_rack: record.code_rack });
                                    setIsLocationModalVisible(false);
                                } catch (error) {
                                    console.error("Gagal memeriksa lokasi rak:", error);
                                }
                            }}
                        />
                    </Modal>
                </div>
            </div>
        </div >
    );
};

export default AddEditPickingItem;
